function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 2,
  fill: "#37556A",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.059 8.719l1.693-1.693c.358-.359 1.277-.775 2.153.101.876.876.428 1.763.07 2.12l-2.329 2.329c-.374.374-1.3.881-2.202-.02",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.941 13.281l-1.693 1.693c-.358.358-1.277.775-2.153-.101-.876-.876-.427-1.763-.07-2.12l2.329-2.329c.374-.374 1.3-.881 2.202.02",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgLinkActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}
export default SvgLinkActive;